module.exports = __webpack_public_path__ + "img/checklistGray.c292e6f5.svg";